<template>
  <!--BEGIN-->
  <b-row class="m-2 hider">
    <b-col>
      <div class="mb-1 mt-1">
        <span v-if="isMinimized" @click="apply('NOT_MINIMIZED')" class="mr-3 hand text-primary">
          <i class="fa fa-check-circle"></i>
          {{ $t("minimization.status.minimized-datasource") }}
        </span>
        <span v-else @click="apply('MINIMIZED')" class="hand">
          <i class="fa fa-circle"></i>
          {{ $t("minimization.status.not-minimized-datasource") }}
        </span>
      </div>
      <div v-if="hasApprovalDetailView() && minimization">
        <h6 class="mt-2" v-if="minimization.approved && minimization.status != 'NOT_MINIMIZED'">{{ $t("minimization.minimization-detail") }}</h6>
        <span v-if="minimization.sentBy" class="mr-2">
          <i class="fa fa-user"></i>
          {{ minimization.sentBy.name }}
        </span>
        <span v-if="minimization.sentAt" v-b-tooltip.hover :title="$t('minimization.update-time')">
          <i class="fa fa-clock"></i>
          {{ minimization.sentAt | date(true) }}
        </span>

        <div v-if="minimization.approved">
          <h6 class="mt-2">{{ $t("minimization.approval-detail") }}</h6>
          <span v-if="minimization.approvedBy" class="mr-2">
            <i class="fa fa-user"></i>
            {{ minimization.approvedBy.name }}
          </span>
          <span v-if="minimization.approvedAt" v-b-tooltip.hover :title="$t('minimization.update-time')">
            <i class="fa fa-clock"></i>
            {{ minimization.approvedAt | date(true) }}
          </span>
        </div>

        <div v-if="hasApprovePermission() && !minimization.approved" class="text-warning mt-2">
          <span @click="approve()" class="text-primary hand">
            <i class="fa fa-check-circle"></i>
            {{ $t("minimization.approve") }}
          </span>
        </div>

        <div v-if="minimization.approved" class="text-success">
          <i class="fa fa-info-circle"></i>
          {{ $t("minimization.collect.approved") }}
        </div>
      </div>
    </b-col>
  </b-row>

  <!--END-->
</template>

<script>
export default {
  props: ["datasource", "department", "process"],
  computed: {
    minimization() {
      return this.datasource.feature.minimization?.collect;
    },
    isMinimized() {
      return this.minimization?.status == "MINIMIZED";
    },
  },
  methods: {
    async apply(status) {
      const response = await this.$store.dispatch("minimization/updateDatasourceCollectMinimization", {
        id: this.datasource._id,
        status,
      });

      this.datasource = response.data;
      this.$emit("onSave");
    },

    async approve() {
      const response = await this.$store.dispatch("minimization/approveDatasourceCollectMinimization", this.datasource._id);
      this.datasource = response.data;
      this.$emit("onSave");
    },

    hasApprovePermission() {
      if (this.currentAccountHasPermissions(["ORGANIZATION_GDPR_PRODUCT_ADMIN", "ORGANIZATION_KVKK_PRODUCT_ADMIN", "ORGANIZATION_LEGAL_ADMIN"])) {
        return true;
      }

      if (this.department.admins.find((a) => a._id == this.currentAccount._id) || this.process.admins.find((a) => a._id == this.currentAccount._id)) {
        return true;
      }

      return false;
    },
    hasApprovalDetailView() {
      if (
        this.currentAccountHasPermissions([
          "ORGANIZATION_GDPR_PRODUCT_ADMIN",
          "ORGANIZATION_KVKK_PRODUCT_ADMIN",
          "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
          "ORGANIZATION_RISK_ADMIN",
          "ORGANIZATION_LEGAL_ADMIN",
        ])
      ) {
        return true;
      }

      if (this.department.admins.find((a) => a._id == this.currentAccount._id) || this.process.admins.find((a) => a._id == this.currentAccount._id)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
h6 {
  font-size: 10px;
  margin: 0px;
  color: gray;
}
</style>
